//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Geeft de toetsnormen voor de berekening van de maximale hypotheek.
     * @return OK
     */
    de_laatste_twee_toetsnormen_ophalen(): Promise<ToetsnormOutput> {
        let url_ = this.baseUrl + "/Hypotheek/Toetsnormen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDe_laatste_twee_toetsnormen_ophalen(_response);
        });
    }

    protected processDe_laatste_twee_toetsnormen_ophalen(response: Response): Promise<ToetsnormOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ToetsnormOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ToetsnormOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ToetsnormOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ToetsnormOutput>(null as any);
    }

    /**
     * Berekent de maximale hypotheek.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    maximale_hypotheek(body: MaximaleHypotheekInput | null | undefined): Promise<MaximaleHypotheekOutput> {
        let url_ = this.baseUrl + "/Hypotheek/MaximaleHypotheek";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaximale_hypotheek(_response);
        });
    }

    protected processMaximale_hypotheek(response: Response): Promise<MaximaleHypotheekOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaximaleHypotheekOutput>(null as any);
    }

    /**
     * Bepaalt de AOW datum op basis van de geboortedatum.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    aow_datum(body: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Hypotheek/AowDatum";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAow_datum(_response);
        });
    }

    protected processAow_datum(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Bereken de maandlasten op basis van looptijd, rente per jaar en hoofdsom.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    maandlasten(body: MaandlastenInput | null | undefined): Promise<MaandlastenOutput> {
        let url_ = this.baseUrl + "/Maandlasten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaandlasten(_response);
        });
    }

    protected processMaandlasten(response: Response): Promise<MaandlastenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaandlastenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaandlastenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaandlastenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaandlastenOutput>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * Geeft de foutcodes die in deze Web API kunnen ontstaan.
     * @return OK
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

/** AflossingsVormType Geen = 0, Annuïteit = 1, Lineair = 2, Levensverzekering = 3, Spaar = 4, Aflosvrij = 5, Krediet = 9, Belegging = 10, Hybride = 11, UnitLinked = 12, Spaarrekening = 13, AnnuïteitUitgesteld = 20, AnnuïteitBlok = 21, KredietNoPay = 22 */
export enum AflossingsVormType {
    Geen = "Geen",
    Annuïteit = "Annuïteit",
    Lineair = "Lineair",
    Levensverzekering = "Levensverzekering",
    Spaar = "Spaar",
    Aflosvrij = "Aflosvrij",
    Krediet = "Krediet",
    Belegging = "Belegging",
    Hybride = "Hybride",
    UnitLinked = "UnitLinked",
    Spaarrekening = "Spaarrekening",
    AnnuïteitUitgesteld = "AnnuïteitUitgesteld",
    AnnuïteitBlok = "AnnuïteitBlok",
    KredietNoPay = "KredietNoPay",
}

export interface BadRequestResult {
    statusCode: number;
}

/** HypotheekvormOptions Annuitair = 0, Lineair = 1 */
export enum HypotheekvormOptions {
    Annuitair = "Annuitair",
    Lineair = "Lineair",
}

/** Resultaat van een maandlastenberekening */
export interface MaandlastResultaat {
    /** Volgnummer van de termijn */
    termijn: number;
    /** Jaar */
    jaar: number;
    /** Maand */
    maand: number;
    /** Verschuldigd bedrag aan aflossing */
    aflossingBedrag: number;
    /** Verschuldigd bedrag aan aflossing gesommeerd voor jaar */
    aflossingTotaalBedrag: number;
    /** Verschuldigd bedrag aan rente */
    renteBedrag: number;
    /** Verschuldigd bedrag aan rente gesommeerd voor jaar */
    renteTotaalBedrag: number;
    /** Brutolast = Rente + Aflossing */
    brutolastBedrag: number;
    /** BrutolastTotaal = RenteTotaal + AflossingTotaal */
    brutolastTotaalBedrag: number;
    /** Restant hoofdsom */
    restantHoofdsom: number;
}

/** Het invoermodel voor de maandlastenberekening. */
export interface MaandlastenInput {
    hypotheekvorm: HypotheekvormOptions;
    /** Hypotheekbedrag */
    hypotheekBedrag: number;
    /** Rentepercentage */
    rentepercentage: number;
    /** Ingangsdatum */
    ingangsdatum: string;
    /** Looptijd in maanden */
    looptijd: number;
}

/** Bevat de output van de maandlastenberekening. */
export interface MaandlastenOutput {
    /** Lijst met resultaten van de berekening. */
    maandlastResultaten: { [key: string]: MaandlastResultaat; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De klantgegevens in het input-model. */
export interface MaximaleHypotheekAanvragerInput {
    /** De geboortedatum van de persoon.
Als de geboortedatum meegegeven wordt, dan worden leeftijd en de pensioendatum bepaald a.d.h.v. die datum.
Als de geboortedatum achterwege gelaten wordt, dan worden Leeftijd en Pensioenleeftijd gebruikt. */
    geboortedatum: string | null;
    /** Het jaarinkomen tot de pensioenleeftijd. */
    toetsInkomen: number | null;
    /** De AOW-datum, vastgesteld a.d.h.v. de geboortedatum. */
    aowDatum: string | null;
    /** Het jaarinkomen na de pensioenleeftijd. */
    pensioenInkomen: number | null;
    /** Het bedrag, op jaarbasis, aan te betalen alimentatie. */
    teBetalenAlimentatie: number | null;
    /** Het bedrag, op jaarbasis, aan te ontvangen alimentatie. */
    teOntvangenAlimentatie: number | null;
    /** De einddatum van de te ontvangen alimentatie. */
    eindDatumTeOntvangenAlimentatie: string | null;
}

/** Het invoermodel voor de maximale hypotheek berekening. */
export interface MaximaleHypotheekInput {
    /** De gegevens van de klanten. */
    aanvragers: MaximaleHypotheekAanvragerInput[] | null;
    uitgangspunten: MaximaleHypotheekUitgangspuntenInput | null;
    toetsrenteBerekeningOpBasisVan: ToetsrenteBerekeningOptions;
    /** Specificatie toetsrente */
    specificatieToetsrentePercentage: number | null;
    /** Gewenste rentevastperiode */
    gewensteRentevastperiodeInMaanden: number | null;
    /** Vrij vermogen */
    vrijVermogen: number | null;
    /** Krediettoetslast */
    kredietToetslast: number | null;
    /** Geeft aan of leningdelen uit het verleden meegenomen moeten worden */
    leningdelenUitVerledenMeenemen: boolean | null;
    /** De leningdelen uit het verleden die meegenomen moeten worden */
    leningdelenUitVerleden: MaximaleHypotheekLeningdeelInput[] | null;
}

/** De invoer van de mee te nemen leningdelen voor de berekening maximale hypotheek. */
export interface MaximaleHypotheekLeningdeelInput {
    /** Unieke identificatie van het leningdeel */
    leningdeelId: string | null;
    aflossingsvorm: AflossingsVormType;
    /** Bedrag leningdeel */
    leningdeelBedrag: number | null;
    /** Opgebouwde waarde */
    opgebouwdeWaardeBedrag: number | null;
    /** Het deel maanden van het restant van de looptijd */
    restantLooptijdInMaanden: number | null;
    /** Het gedeelte (als bedrag) van het hypotheekbedrag dat in box 3 zit */
    box3Bedrag: number | null;
}

/** Bevat de output van de maximale hypotheek berekening. */
export interface MaximaleHypotheekOutput {
    /** Lijst met resultaten van de berekening. */
    maximaleHypotheken: { [key: string]: MaximaleHypotheekResultaat; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de maximale hypotheek berekening. */
export interface MaximaleHypotheekResultaat {
    uitslag: UitslagOptions;
    /** Gets or sets code van het product zoals deze in de Adviesbox
producten-database is gedefinieerd. */
    productCode: number | null;
    /** Gets or sets productnaam. */
    productnaam: string | null;
    /** Gets or sets code van de maatschappij zoals deze in de Adviesbox
producten-database is gedefinieerd. */
    maatschappijCode: string | null;
    /** Gets or sets verkorte naam van de maatschappij. */
    maatschappijNaam: string | null;
    /** De toetsrente waarmee getoetst is / hypotheekrente */
    toetsrente: number | null;
    /** Bedrag van de extra aflossing */
    extraAflossing: number | null;
    /** Looptijd van de hypotheek in jaren. */
    looptijd: number | null;
    /** De maximale hypotheek op inkomen */
    maximaleHypotheek: number | null;
    /** De maximale hypotheek op het onderpand */
    maximaleHypotheekOnderpand: number | null;
}

/** De uitgangspunten voor de maximale hypotheekberekening in het input-model. */
export interface MaximaleHypotheekUitgangspuntenInput {
    /** Toetsen met NHG normen. */
    nhg: boolean | null;
    tarievenNorm: TarievenNorm | null;
    /** Looptijd van de gewenste hypotheek in jaren. */
    looptijd: number | null;
    /** Marktwaarde waarmee rekening gehouden moet worden tijdens de berekening. */
    marktwaarde: number | null;
    /** Het gewenste hypotheekbedrag. */
    gewensteHypotheek: number | null;
    /** Het gedeelte van de hypotheek dat in box3 terecht komt. */
    box3Deel: number | null;
    /** Het bedrag wat jaarlijks aan erfpachtcanon betaald moet worden. */
    erfpachtCanon: number | null;
    /** Geeft de energie (label) klasse in welke de woning valt volgens de HDN keuzelijst EnergieKlasseType */
    energieklasse: number | null;
}

export interface TarievenNorm {
    jaar: number;
    maand: number;
}

/** De toetsnorm */
export interface Toetsnorm {
    /** Het jaar van de toetsnorm */
    jaar: number;
    /** De maand van de toetsnorm */
    maand: number;
    /** De omschrijving van de toetsnorm */
    omschrijving: string | null;
    /** Code ter identificatie van de toetsnorm; gebruik deze als 'Value' van de keuzelijst-items */
    code: number;
}

/** Bevat output met de laatste 2 toetsnormen. */
export interface ToetsnormOutput {
    /** Lijst met toetsnormen. */
    toetsnormen: { [key: string]: Toetsnorm; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** ToetsrenteBerekeningOptions SpecificatieToetsrente = 0, GewensteRentevastperiode = 1 */
export enum ToetsrenteBerekeningOptions {
    SpecificatieToetsrente = "SpecificatieToetsrente",
    GewensteRentevastperiode = "GewensteRentevastperiode",
}

/** UitslagOptions Wit = 0, Groen = 1, Oranje = 2, Rood = 3 */
export enum UitslagOptions {
    Wit = "Wit",
    Groen = "Groen",
    Oranje = "Oranje",
    Rood = "Rood",
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}